import React from 'react'

import Component from './component'

const Container = ({ order_ids }) => {

  const mergedProps = {
    order_ids
  }

  return (
    <Component {...mergedProps} />
  )
}

export default Container
